/**
 * Formatter untuk mengolah dan memformat data laporan KMKOP.
 *
 * @class KmkopFormater
 */
export default class KmkopFormater {
  /**
   * @param {{
   * date:string,
   * assessmentDate:string,
   * location:string,
   * instructorName:string,
   * userName:string,
   * selectedParticipant:array<>,
   * participantList:array<{
   *    participantId:number,
   *    minepermitNumber:string,
   *    name:string,
   *    company:string,
   *    position:string
   * }>
   * evaluationList:array<{
   *    competencyId:number,
   *    title:string,
   *    participant:array<{
   *      participantId:number,
   *      postTest:number
   *      }>
   * }>
   * }} data
   */
  constructor(data = {}) {
    this.minScore = 75;
    this.instructorName = data.instructorName ?? null;
    this.location = data.location ?? null;
    this.date = data.date ?? null;
    this.assessmentDate = data.assessmentDate ?? null;
    this.evaluationList = data.evaluationList ?? [];
    this.participantList = data.participantList ?? [];
    this.selectedParticipant = data.selectedParticipant ?? [];
    this.userName = data.userName ?? "no name";
    this.titleIdSquence = [
      1062, // Pengenalan Tool
      1077, // Hand Injury
      1111, // Jack & Stand
      1078, // Hydrocarbon dan limbah B3
      1112, // Pengendalian Kebisingan
      1079, // Manual Handling
      231, // Keselamatan Isolasi (LOTO)
    ];
  }
  format() {
    const prtp = this.selectedParticipant.map((v) => {
      const score = this.getCompleteScore(v);
      const filterdParticipant = this.participantList.find((val) => val.participantId === v);
      return {
        nama: filterdParticipant.name,
        minePermitNumb: filterdParticipant.minepermitNumber,
        company: filterdParticipant.company,
        position: filterdParticipant.position,
        score: score,
        result: this.getResult(score),
      };
    });
    return {
      date: this.date,
      assDate: this.assessmentDate,
      location: this.location,
      instructor: this.instructorName,
      userName: this.userName,
      participant: prtp,
    };
  }
  getResult(score) {
    return score.some((v) => v.score === null || v.score < this.minScore) ? "NYC" : "CO";
  }
  /**
   * Mengambil nilai post-test peserta berdasarkan urutan title ID.
   *
   * @param {number} participantId
   * @returns {Array<{id: number, score: number | null}>}
   */
  getCompleteScore(participantId) {
    return this.titleIdSquence.map((titleId) => {
      const evaluation = this.evaluationList.find((item) => item.competencyId === titleId);
      const participant = evaluation?.participant.find((item) => item.participantId === participantId);
      return {
        id: titleId,
        score: participant?.postTest ?? null,
      };
    });
  }
}
